import { appData } from '@/mocks/home';

export default function AppEntry() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-3">
                <i className="ri-smartphone-line"></i>
                移动端入口
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                {appData.title}
              </h2>
              <p className="text-lg text-foreground-600 font-medium mb-4">
                {appData.subtitle}
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
                {appData.description}
              </p>
              <div className="flex flex-wrap gap-2 justify-center lg:justify-start mb-7">
                {appData.features.map((feat) => (
                  <span
                    key={feat}
                    className="px-3 py-1.5 rounded-full bg-background-100 border border-background-200/70 text-xs text-foreground-600 font-medium whitespace-nowrap"
                  >
                    <i className="ri-check-line text-primary-500 mr-1"></i>
                    {feat}
                  </span>
                ))}
              </div>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#app"
                  className="inline-flex items-center px-6 py-3 rounded-full bg-foreground-900 text-background-50 font-medium text-sm hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-apple-line mr-1.5"></i>
                  App Store 下载
                </a>
                <a
                  href="#app"
                  className="inline-flex items-center px-6 py-3 rounded-full border-2 border-foreground-300 text-foreground-700 font-medium text-sm hover:border-primary-400 hover:text-primary-500 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-android-line mr-1.5"></i>
                  安卓版下载
                </a>
              </div>
            </div>
            <div className="flex-shrink-0 flex items-center gap-6">
              <div className="hidden md:block w-[140px] h-[280px] rounded-2xl overflow-hidden shadow-lg">
                <img
                  src={appData.phoneImage}
                  alt="51吃瓜网App移动端截图界面"
                  title="51吃瓜网App - 随时随地吃瓜"
                  className="w-full h-full object-cover"
                  width="500"
                  height="700"
                />
              </div>
              <div className="w-[160px] h-[160px] rounded-2xl overflow-hidden shadow-md bg-background-50 p-3 flex items-center justify-center border border-background-200/70">
                <img
                  src={appData.qrImage}
                  alt="51吃瓜网App下载二维码"
                  title="扫码下载51吃瓜网App"
                  className="w-full h-full object-contain"
                  width="400"
                  height="400"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}